import React from 'react';
import PropTypes from 'prop-types';

import {
  SETTINGS_LABELS,
  SETTINGS_ICONS,
  EDIT_TOOL_INFO,
  EDIT_COMPANY_INFO,
  CLAIM_THIS_PAGE,
  JOIN_COMPANY
} from '../../../../shared/constants/settings';
import {MenuPopover} from '../../../../shared/library/popovers/menu';
import withErrorBoundary from '../../../../shared/enhancers/error-boundary';

const Menu = ({slug, name, isOwner, hasOwner}) => {
  const handleMenuClick = ({slug, name}) => option => {
    switch (option) {
      case EDIT_TOOL_INFO:
        window.location = `/${slug}/edit`;
        break;
      case EDIT_COMPANY_INFO:
        window.location = `/companies/${slug}/edit`;
        break;
      case CLAIM_THIS_PAGE:
        window.location = `/claim-service/${slug}`;
        break;
      case JOIN_COMPANY:
        window.location = `/become-company-member?company=${name}`;
        break;
    }
  };

  const userCanEdit = setting => setting !== CLAIM_THIS_PAGE && setting !== JOIN_COMPANY && isOwner;
  const userCanJoin = setting => setting === JOIN_COMPANY && hasOwner && !isOwner;
  const userCanClaim = setting => setting === CLAIM_THIS_PAGE && !hasOwner && !isOwner;

  const allMenuOptions = [EDIT_TOOL_INFO, EDIT_COMPANY_INFO, CLAIM_THIS_PAGE, JOIN_COMPANY].map(
    setting => ({
      id: setting,
      label: SETTINGS_LABELS[setting],
      icon: SETTINGS_ICONS[setting],
      visible: userCanEdit(setting) || userCanJoin(setting) || userCanClaim(setting)
    })
  );
  const visibleMenuItems = allMenuOptions
    .filter(item => {
      return item.visible === true;
    })
    .map(item => {
      return item;
    });

  return <MenuPopover options={visibleMenuItems} onClick={handleMenuClick({slug, name})} />;
};

Menu.propTypes = {
  slug: PropTypes.string,
  name: PropTypes.string,
  isOwner: PropTypes.bool,
  hasOwner: PropTypes.bool
};

export default withErrorBoundary(true)(Menu);
